import { render, staticRenderFns } from "./CustomMenu.vue?vue&type=template&id=45851e29"
import script from "./CustomMenu.vue?vue&type=script&lang=js"
export * from "./CustomMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomMenu.vue?vue&type=style&index=0&id=45851e29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports